import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentModule } from './document/document.module';
import { ReportModule } from './report/report.module';
import { ProfileModule } from './profile/profile.module';
import { SearchModule } from './search/search.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { SaleTaxModule } from './saletax/saletax.module';
import { BillingModule } from './billing/billing.module';
import { TaxReportModule } from './tax-report/tax-report.module';
import { ZipFileModule } from './zip-file/zip-file.module';
import { DownloadModule } from './download/download.module';
import { EmailDashboardModule } from './email-dashboard/email-dashboard.module';
import { EmailDashboardOverdueModule} from './email-dashboard-overdue/email-dashboard-overdue.module';
import { PowerBiDashboardModule } from './power-bi-dashboard/power-bi-dashboard.module';
import { ManageRequestModule } from './manage-request/manage-request.module';
import {OperationLogModule} from "./operation-log/operation-log.module";

@NgModule({
  imports: [
    CommonModule,
    DocumentModule,
    ReportModule,
    SearchModule,
    DashboardModule,
    BillingModule,
    SaleTaxModule,
    ProfileModule,
    TaxReportModule,
    ZipFileModule,
    DownloadModule,
    EmailDashboardModule,
    EmailDashboardOverdueModule,
    PowerBiDashboardModule,
    ManageRequestModule,
    OperationLogModule
  ]
})
export class FeaturesModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/features/features.module.ts